import { useState, type FormEvent } from 'react'

import { ApiError } from '@/api/client'
import { Button, Field, Message } from '@/components/ui'
import { useAuth } from '@/hooks/useAuth'
import styles from './LoginPage.module.css'

export function LoginPage() {
  const { login } = useAuth()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  function submit(event: FormEvent) {
    event.preventDefault()
    void attempt()
  }

  async function attempt() {
    setError(null)
    setBusy(true)
    try {
      await login(username, password)
    } catch (cause) {
      setError(cause instanceof ApiError ? cause.message : 'Connexion impossible.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className={styles.screen}>
      <form className={styles.panel} onSubmit={submit}>
        <div className={styles.brand}>
          <div className={styles.mark} aria-hidden>
            Y
          </div>
          <h1>Convertisseur de catalogue</h1>
          <p>Connectez-vous pour continuer</p>
        </div>

        <div className={styles.fields}>
          <Field label="Identifiant" htmlFor="username">
            <input
              id="username"
              type="text"
              autoComplete="username"
              autoFocus
              required
              value={username}
              onChange={(event) => setUsername(event.target.value)}
            />
          </Field>
          <Field label="Mot de passe" htmlFor="password">
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </Field>
        </div>

        {error ? <Message kind="error">{error}</Message> : null}

        <Button type="submit" className={styles.submit} busy={busy}>
          {busy ? 'Connexion…' : 'Se connecter'}
        </Button>

        <p className={styles.note}>
          Ce poste de travail donne accès aux prix d’achat et aux barèmes de marge. Ne partagez pas ces
          identifiants.
        </p>
      </form>
    </div>
  )
}
